import Main from "../views/Main";
import emptyView from "../components/menu/empty-view.vue";
import dashImg from "../assets/menu-img/dashboard.png";
import yunyingImg from "../assets/menu-img/yunying.png";
import yidongImg from "../assets/menu-img/yidongduan.png";
import chargeImg from "../assets/menu-img/charge.png";
import custImg from "../assets/menu-img/cust.png";
import orderImg from "../assets/menu-img/order.png";
import caiwuImg from "../assets/menu-img/caiwu.png";
import fankuiImg from "../assets/menu-img/fankui.png";
import settingImg from "../assets/menu-img/setting.png";
import shop from "../assets/menu-img/shop.png";
import active from "../assets/menu-img/activity.png";

let menuRouter = [];
/**
 菜单路由
 wk 2019-11-29
 */
menuRouter = [
  {
    path: "/dbManage",
    meta: {
      title: "仪表盘",
      type: "noChild", // 单个的一级菜单
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/dashboard.png'
      icon: dashImg
    },
    name: "dbManage",
    component: Main,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          parent: ["dbManage"],
          current: ["dashboard"],
          title: "仪表盘"
        },
        component: resolve => {
          require(["../views/dashboard/index.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/orderManage",
    meta: {
      title: "运营商管理",
      type: "noChild", // 单个的一级菜单
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/yunying.png'
      icon: yunyingImg
    },
    name: "dealerManage",
    component: Main,
    children: [
      {
        path: "/dealerManageList",
        name: "dealerManageList",
        meta: {
          parent: ["dealerManage"],
          current: ["dealerManageList"],
          title: "运营商管理"
        },
        component: resolve => {
          require(["../views/dealer-manage/list.vue"], resolve);
        }
      }
    ]
  },

  {
    path: "/operationManagement",
    meta: {
      title: "运维管理",
      type: "hasChild",
      icon: yunyingImg
    },
    name: "operationManagement",
    component: Main,
    children: [
      {
        path: "/powerModification",
        name: "powerModification",
        meta: {
          parent: ["operationManagement"],
          current: ["powerModification"],
          title: "设备功率修改"
        },
        component: resolve => {
          require([
            "../views/operationManagement/powerModification/list.vue"
          ], resolve);
        }
      },
      {
        path: "/equipmentChange",
        name: "equipmentChange",
        meta: {
          parent: ["operationManagement"],
          current: ["equipmentChange"],
          title: "设备变更站点"
        },
        component: resolve => {
          require([
            "../views/operationManagement/equipmentChange/list.vue"
          ], resolve);
        }
      },
      {
        path: "/deviceOnline",
        name: "deviceOnline",
        meta: {
          parent: ["operationManagement"],
          current: ["deviceOnline"],
          title: "设备上线申请"
        },
        component: resolve => {
          require([
            "../views/operationManagement/deviceOnline/list.vue"
          ], resolve);
        }
      },
      {
        path: "/equipmentOffline",
        name: "equipmentOffline",
        meta: {
          parent: ["operationManagement"],
          current: ["equipmentOffline"],
          title: "设备下线申请"
        },
        component: resolve => {
          require([
            "../views/operationManagement/equipmentOffline/list.vue"
          ], resolve);
        }
      },
      {
        path: "/actionRecord",
        name: "actionRecord",
        meta: {
          parent: ["operationManagement"],
          current: ["actionRecord"],
          title: "设备动作记录"
        },
        component: resolve => {
          require([
            "../views/operationManagement/actionRecord/list.vue"
          ], resolve);
        }
      }
    ]
  },
  {
    path: "/mobileManage",
    meta: {
      title: "移动端管理",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn//zdj4/menu/yidongduan.png',
      icon: yidongImg
    },
    name: "mobileManage",
    component: Main,
    children: [
      {
        path: "/noticeList",
        name: "noticeList",
        meta: {
          parent: ["mobileManage"],
          current: ["noticeList"],
          title: "通知管理"
        },
        component: resolve => {
          require(["../views/mobile-manage/notice/list.vue"], resolve);
        }
      },
      {
        path: "/openScreenList",
        name: "openScreenList",
        meta: {
          parent: ["mobileManage"],
          current: ["openScreenList"],
          title: "开屏管理"
        },
        component: resolve => {
          require(["../views/mobile-manage/open-screen/list.vue"], resolve);
        }
      },
      {
        path: "/bannerList",
        name: "bannerList",
        meta: {
          parent: ["mobileManage"],
          current: ["bannerList"],
          title: "banner管理"
        },
        component: resolve => {
          require(["../views/mobile-manage/banner/list.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/chargeManage",
    meta: {
      title: "充电管理",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/charge.png'
      icon: chargeImg
    },
    name: "chargeManage",
    component: Main,
    children: [
      {
        path: "/pileStationList",
        name: "pileStationList",
        meta: {
          parent: ["chargeManage"],
          current: ["pileStationList"],
          title: "电站管理"
        },
        component: resolve => {
          require(["../views/charging-manage/pile-station/list.vue"], resolve);
        }
      },
      {
        path: "/pileList",
        name: "pileList",
        meta: {
          parent: ["chargeManage"],
          current: ["pileList"],
          title: "充电桩管理"
        },
        component: resolve => {
          require(["../views/charging-manage/pile/list.vue"], resolve);
        }
      },
      {
        path: "/pileModelList",
        name: "pileModelList",
        meta: {
          parent: ["chargeManage"],
          current: ["pileModelList"],
          title: "充电桩型号管理"
        },
        component: resolve => {
          require(["../views/charging-manage/pile-model/list.vue"], resolve);
        }
      },
      {
        path: "/pileTotal",
        name: "pileTotal",
        meta: {
          parent: ["chargeManage"],
          current: ["pileTotal"],
          title: "电表总表"
        },
        component: resolve => {
          require(["../views/charging-manage/pile-total/list.vue"], resolve);
        }
      },
        {
            path: "/ZDBoxManage",
            name: "ZDBoxManage",
            meta: {
                parent: ["chargeManage"],
                current: ["ZDBoxManage"],
                title: "zd-box管理"
            },
            component: resolve => {
                require(["../views/charging-manage/zd-box-manage/index.vue"], resolve);
            }
        },
        {
            path: "/ZDBoxModelManage",
            name: "ZDBoxModelManage",
            meta: {
                parent: ["chargeManage"],
                current: ["ZDBoxModelManage"],
                title: "zd-box型号管理"
            },
            component: resolve => {
                require(["../views/charging-manage/zd-box-model-manage/index.vue"], resolve);
            }
        },
    ]
  },
  {
    path: "/custManage",
    meta: {
      title: "客户管理",
      type: "hasChild", // 单个的一级菜单
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/cust.png'
      icon: custImg
    },
    name: "custManage",
    component: Main,
    children: [
      {
        path: "/custManageList",
        name: "custManageList",
        meta: {
          parent: ["custManage"],
          current: ["custManageList"],
          title: "客户管理"
        },
        component: resolve => {
          require(["../views/cust-manage/list.vue"], resolve);
        }
      },
      {
        path: "/SiteDiscountRate",
        name: "SiteDiscountRate",
        meta: {
          parent: ["custManage"],
          current: ["SiteDiscountRate"],
          title: "客户站点折扣费率管理"
        },
        component: () =>
          import("../views/cust-manage/SiteDiscountRate/SiteDiscountRate.vue")
      }
    ]
  },
  {
    name: "orderManage",
    path: "/orderManage",
    meta: {
      title: "订单管理",
      type: "hasChild", // 单个的一级菜单
      // icon:'http://img.cdn.wxzhida.cn/zdj4/menu/order.png'
      icon: orderImg
    },
    component: Main,
    children: [
      {
        path: "/orderManageList",
        name: "orderManageList",
        meta: {
          parent: ["orderManage"],
          current: ["orderManageList"],
          title: "订单管理"
        },
        component: resolve => {
          require(["../views/order-manage/list.vue"], resolve);
        }
      },
      {
        path: "/seatFeeOrder",
        name: "seatFeeOrder",
        meta: {
          parent: ["orderManage"],
          current: ["seatFeeOrder"],
          title: "占位订单管理"
        },
        component: resolve => {
          require(["../views/order-manage/seatFee-order/index.vue"], resolve);
        }
      },
      {
        path: "/energyStorage",
        name: "energyStorage",
        meta: {
          parent: ["orderManage"],
          current: ["energyStorage"],
          title: "储能充放电记录"
        },
        component: resolve => {
          require(["../views/order-manage/energy-storage-battery/index.vue"], resolve);
        }
      },
      {
        path: "/dischargeRecord",
        name: "dischargeRecord",
        meta: {
          parent: ["orderManage"],
          current: ["dischargeRecord"],
          title: "放电订单列表"
        },
        component: resolve => {
          require(["../views/order-manage/discharge-record/index.vue"], resolve);
        }
      },
    ]
  },
  {
    path: "/financeManage",
    meta: {
      title: "财务管理",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/caiwu.png'
      icon: caiwuImg
    },
    name: "financeManage",
    component: Main,
    children: [
      {
        path: "/financialStatements",
        name: "financialStatements",
        meta: {
          parent: ["financeManage"],
          current: ["financialStatements"],
          title: "财务报表"
        },
        component: resolve => {
          require([
            "../views/finance-manage/financial-statements/index.vue"
          ], resolve);
        }
      },
      {
        path: "/accountsReviewList",
        name: "accountsReviewList",
        meta: {
          parent: ["financeManage"],
          current: ["accountsReviewList"],
          title: "入账审核"
        },
        component: resolve => {
          require([
            "../views/finance-manage/accounts-review/list.vue"
          ], resolve);
        }
      },
      {
        path: "/financeReviewList",
        name: "financeReviewList",
        meta: {
          parent: ["financeManage"],
          current: ["financeReviewList"],
          title: "财务审核"
        },
        component: resolve => {
          require(["../views/finance-manage/finance-review/list.vue"], resolve);
        }
      },
      {
        path: "/withdrawalList",
        name: "withdrawalList",
        meta: {
          parent: ["financeManage"],
          current: ["withdrawalList"],
          title: "提现管理"
        },
        component: resolve => {
          require(["../views/finance-manage/withdrawal/list.vue"], resolve);
        }
      },
      {
        path: "/stationReport",
        name: "stationReport",
        meta: {
          parent: ["financeManage"],
          current: ["stationReport"],
          title: "电站分析"
        },
        component: resolve => {
          require(["../views/finance-manage/station-report/list.vue"], resolve);
        }
      },
      {
        path: "/accountsStatementList",
        name: "accountsStatementList",
        meta: {
          parent: ["financeManage"],
          current: ["accountsStatementList"],
          title: "对账信息管理"
        },
        component: resolve => {
          require([
            "../views/finance-manage/accounts-statement/list.vue"
          ], resolve);
        }
      },
      {
        path: "/pileReport",
        name: "pileReport",
        meta: {
          parent: ["financeManage"],
          current: ["pileReport"],
          title: "充电桩报表"
        },
        component: resolve => {
          require(["../views/finance-manage/pile-report/list.vue"], resolve);
        }
      },
      {
        path: "/custinvoicList",
        name: "custinvoicList",
        meta: {
          parent: ["financeManage"],
          current: ["custinvoicList"],
          title: "开票管理"
        },
        component: resolve => {
          require([
            "../views/finance-manage/Invoicing-management/list.vue"
          ], resolve);
        }
      },
      {
        path: "/operatorSettlement",
        name: "operatorSettlement",
        meta: {
          parent: ["financeManage"],
          current: ["operatorSettlement"],
          title: "运营商结算"
        },
        component: resolve => {
          require([
            "../views/finance-manage/operator-settlement/list.vue"
          ], resolve);
        }
      },
      {
        path: "/invoicingOrderFlow",
        name: "invoicingOrderFlow",
        meta: {
          parent: ["financeManage"],
          current: ["invoicingOrderFlow"],
          title: "开票订单流水"
        },
        component: resolve => {
          require([
            "../views/finance-manage/invoicingOrderFlow/list.vue"
          ], resolve);
        }
      },
      {
        path: "/siteOperations",
        name: "siteOperations",
        meta: {
          parent: ["financeManage"],
          current: ["siteOperations"],
          title: "站点运营"
        },
        component: resolve => {
          require(["../views/finance-manage/siteOperations/list.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/activity",
    meta: {
      title: "内容管理",
      type: "noChild", // 单个的一级菜单
      // icon:'http://img.cdn.wxzhida.cn/zdj4/menu/fankui.png'
      icon: active
    },
    name: "activity",
    component: Main,
    children: [
      {
        path: "/activityManagement",
        name: "activityManagement",
        meta: {
          parent: ["activity"],
          current: ["activityManagement"],
          title: "活动管理"
        },
        component: resolve => {
          require(["../views/service-activity/index.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/commodity",
    meta: {
      title: "商城管理",
      type: "noChild", // 单个的一级菜单
      // icon:'http://img.cdn.wxzhida.cn/zdj4/menu/fankui.png'
      icon: shop
    },
    name: "commodity",
    component: Main,
    children: [
      {
        path: "/commodityList",
        name: "commodityList",
        meta: {
          parent: ["commodity"],
          current: ["commodityList"],
          title: "商城管理"
        },
        component: resolve => {
          require(["../views/commodity-list/index.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/serviceFeedback",
    meta: {
      title: "服务和反馈",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/fankui.png'
      icon: fankuiImg
    },
    name: "serviceFeedback",
    component: Main,
    children: [
      {
        path: "/feedbackRouter",
        name: "feedbackRouter",
        meta: {
          parent: ["serviceFeedback"],
          current: ["feedbackRouter"],
          title: "去腾讯吐个槽"
        },
        component: resolve => {
          require(["../views/service-feedback/index.vue"], resolve);
        }
      },
      {
        path: "/serviceRecordList",
        name: "serviceRecordList",
        meta: {
          parent: ["serviceFeedback"],
          current: ["serviceRecordList"],
          title: "服务记录"
        },
        component: resolve => {
          require(["../views/service-record/list.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/systemManage",
    meta: {
      title: "系统管理",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/setting.png'
      icon: settingImg
    },
    name: "systemManage",
    component: Main,
    children: [
      {
        path: "/message",
        name: "message",
        meta: {
          parent: ["systemManage"],
          current: ["message"],
          title: "消息管理"
        },
        component: resolve => {
          require(["../views/system-manage/message/list.vue"], resolve);
        }
      },
      {
        path: "/userManageList",
        name: "user_list",
        meta: {
          parent: ["systemManage"],
          current: ["user_list"],
          title: "用户管理"
        },
        component: resolve => {
          require(["../views/system-manage/user-manage/list.vue"], resolve);
        }
      },
      {
        path: "/roleManageList",
        name: "role_list",
        meta: {
          parent: ["systemManage"],
          current: ["role_list"],
          title: "角色管理"
        },
        component: resolve => {
          require(["../views/system-manage/role-manage/list.vue"], resolve);
        }
      },
      {
        path: "/charginglogList",
        name: "charginglog_list",
        meta: {
          parent: ["systemManage"],
          current: ["charginglog_list"],
          title: "充电日志"
        },
        component: resolve => {
          require(["../views/system-manage/charging-log/list.vue"], resolve);
        }
      },
      {
        path: "/downloadCenter",
        name: "downloadCenter",
        meta: {
          parent: ["systemManage"],
          current: ["downloadCenter"],
          title: "下载中心"
        },
        component: resolve => {
          require(["../views/system-manage/downloadCenter/list.vue"], resolve);
        }
      },
      {
        path: "/operationRecords",
        name: "operationRecords",
        meta: {
          parent: ["systemManage"],
          current: ["operationRecords"],
          title: "操作记录"
        },
        component: resolve => {
          require([
            "../views/system-manage/operationRecords/list.vue"
          ], resolve);
        }
      },
      {
        path: "/pushLogList",
        name: "push_log_list",
        meta: {
          parent: ["systemManage"],
          current: ["push_log_list"],
          title: "推送日志"
        },
        component: resolve => {
          require(["../views/system-manage/push-log/list.vue"], resolve);
        }
      }
    ]
  }
];

export default menuRouter;
